import { forwardRef, useEffect } from 'react';

// material-ui
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormHelperText,
    Grid,
    Slide,
    TextField
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// project imports
import { gridSpacing } from 'store/constant';
import boardLogSchema from 'utils/schema/BoardLogSchema';

// third party
import moment from 'moment';
import { useFormik } from 'formik';

// animation
const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const Filter = ({ filterObj, open, handleCloseDialog, setFilterObj, setPage }) => {

    const filterCourtBookings = () => {
        const formikValues = { ...formik.values };
        if (formikValues.start_date) {
            formikValues.start_date = moment(formikValues.start_date, 'ddd MMM DD YYYY').format('YYYY-MM-DD')
        }
        if (formikValues.end_date) {
            formikValues.end_date = moment(formikValues.end_date, 'ddd MMM DD YYYY').format('YYYY-MM-DD')
        }
        setFilterObj(formikValues);
        setPage(1);
        handleCloseDialog();
    };

    const resetFilterForm = () => {
        formik.resetForm();
        setFilterObj({
            start_date: null,
            end_date: null,
            uuid_board: filterObj.uuid_board ? filterObj.uuid_board : []
        });
        setPage(1);
    };

    const formik = useFormik({
        initialValues: {
            start_date: null,
            end_date: null,
            uuid_board: filterObj.uuid_board
        },
        validationSchema: boardLogSchema,
        onSubmit: filterCourtBookings
    });

    const setFormValue = () => {
        formik.setFieldValue('start_date', filterObj.start_date ? moment(filterObj.start_date).format('ddd MMM DD YYYY') : null);
        formik.setFieldValue('end_date', filterObj.end_date ? moment(filterObj.end_date).format('ddd MMM DD YYYY') : null);
        formik.setFieldValue('uuid_board', filterObj.uuid_board.length ? filterObj.uuid_board : []);
    };

    useEffect(() => {
        if (filterObj) {
            setFormValue();
        }
    }, []);

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseDialog}
            sx={{
                '&>div:nth-of-type(3)': {
                    justifyContent: 'flex-end',
                    '&>div': {
                        m: 0,
                        borderRadius: '0px',
                        maxWidth: 450,
                        maxHeight: '100%',
                        height: '100%'
                    }
                }
            }}
        >
            {open && (
                <>
                    <DialogTitle>Filter</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={gridSpacing} sx={{ mt: 0.25 }}>
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Start Date"
                                        views={["year", "month", "day"]}
                                        inputFormat="dd-MM-yyyy"
                                        onChange={(date) => formik.setFieldValue("start_date", date ? date : "")}
                                        onBlur={formik.handleBlur}
                                        disableFuture
                                        value={formik.values.start_date}
                                        renderInput={(params) => <TextField fullWidth name="start_date" onBlur={formik.handleBlur} autoComplete="off"
                                            value={formik.values.start_date} onChange={formik.handleChange} onKeyDown={(e) => { e.preventDefault(); }} size="medium" {...params} />}
                                    />
                                </LocalizationProvider>
                                {formik.touched.start_date && formik.errors.start_date && (
                                    <FormHelperText error id="standard-weight-helper-date-start_date-filter">
                                        {formik.errors.start_date}
                                    </FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="End Date"
                                        views={["year", "month", "day"]}
                                        inputFormat="dd-MM-yyyy"
                                        onChange={(date) => formik.setFieldValue("end_date", date ? date : "")}
                                        onBlur={formik.handleBlur}
                                        disableFuture
                                        value={formik.values.end_date}
                                        renderInput={(params) => <TextField fullWidth name="end_date" onBlur={formik.handleBlur} autoComplete="off"
                                            value={formik.values.end_date} onChange={formik.handleChange} onKeyDown={(e) => { e.preventDefault(); }} size="medium" {...params} />}
                                    />
                                </LocalizationProvider>
                                {formik.touched.end_date && formik.errors.end_date && (
                                    <FormHelperText error id="standard-weight-helper-date-end_date-filter">
                                        {formik.errors.end_date}
                                    </FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={gridSpacing} sx={{ mt: 3, justifyContent: 'right' }}>
                            <Button variant="contained" color="inherit" onClick={handleCloseDialog} sx={{ marginRight: '10px' }}>
                                Close
                            </Button>
                            <Button variant="contained" color="error" onClick={resetFilterForm} sx={{ marginRight: '10px' }}>
                                Reset
                            </Button>
                            <Button variant="contained" color="primary" onClick={formik.handleSubmit}>
                                Filter
                            </Button>
                        </Grid>
                    </DialogContent>
                </>
            )}
        </Dialog>
    );
};

export default Filter;
